
import { matchPath } from 'react-router-dom'
import PropTypes from 'prop-types'
import { List, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom'
import NavigationItem from './navigation-item'
import { themeV5 } from 'theme/v5'

const NavigationList = ({ pages, ...rest }) => (
  <List>
    {pages.reduce(
      (items, page) => reduceChildRoutes({ items, page, ...rest }),
      []
    )}
  </List>
)

NavigationList.propTypes = {
  depth: PropTypes.number,
  pages: PropTypes.array
}

const reduceChildRoutes = ({ router, items, page, depth }) => {

  if (page.children) {
    const open = matchPath({ path: page.href, end: false }, router.pathname)

    items.push(
      <NavigationItem
        depth={depth}
        icon={page.icon}
        key={page.title}
        label={page.label}
        open={Boolean(open)}
        title={page.title}>
        <NavigationList
          depth={depth + 1}
          pages={page.children}
          router={router} />
      </NavigationItem>
    )
  }
  else {
    items.push(
      <NavigationItem
        depth={depth}
        href={page.href}
        icon={page.icon}
        key={page.title}
        label={page.label}
        title={page.title} />
    )
  }

  return items
}

const Navigation = ({ title, pages, className, component: Component, ...rest }) => {
  const router = useLocation()

  return (
    <Component
      {...rest}
      className={className}
      style={{ marginBottom: '24px' }}>
      {title && (
        <Typography
          sx={{
            display: 'none',
            color: themeV5.palette.icons,
            '@media (min-width: 1280px)': {
              display: 'flex',
            },
          }}
          variant="overline">
          {title}
        </Typography>
      )}
      <NavigationList
        depth={0}
        pages={pages}
        router={router} />
    </Component>
  )
}

Navigation.propTypes = {
  className: PropTypes.string,
  component: PropTypes.any,
  pages: PropTypes.array.isRequired,
  title: PropTypes.string
}

Navigation.defaultProps = {
  component: 'nav'
}

export default Navigation
